<template>
  <div class="myInvoiceBox">
    <div>
      <div class="orderSearchBox">
        <el-date-picker
            v-model="createDateValue"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-input v-model="orderNo" placeholder="订单编号"></el-input>
        <el-select v-model="orderType" clearable placeholder="订单分类">
            <el-option label="商城" value="SHOP"> </el-option>
            <el-option label="打印" value="PRINT"> </el-option>
            <el-option label="软件" value="SOFTWARE"> </el-option>
            <el-option label="设计" value="DESIGN"> </el-option>
            <el-option label="模型" value="MODEL"> </el-option>
            <el-option label="服务" value="SERVICE"> </el-option>
        </el-select>
        <el-select v-model="invoiceStatus" clearable placeholder="开票状态">
          <el-option label="已开票" value="PASS"> </el-option>
          <el-option label="开票中" value="EXAMINE"> </el-option>
          <el-option label="已拒绝" value="REFUSE"> </el-option>
        </el-select>

        <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="clearMessage">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
        <div class="orderListTable">
            <ul class="tableHeader">
                <li class="titleImg" style="text-align: left;padding-left: 20px;">订单名称</li>
                <li class="invoiceTime">订单类型</li>
                <li class="invoiceTime">申请时间</li>
                <!-- <li class="invoiceMes">发票抬头</li> -->
                <li class="invoiceClass">发票类型</li>
                <li class="invoiceCon">发票介质</li>
                <li class="invoiceMoney" style="width:100px">发票金额</li>
                <li class="status">状态</li>
                <li class="operation">操作</li>
            </ul>
            <ul class="tableBody" v-if="printMessage.length != 0" v-loading="loading">
                <li
                    class="bodyItem"
                    v-for="(printItems, index) in printMessage"
                    :key="index"
                >
                    <div class="itemTop">
                        <div :data-clipboard-text="printItems.orderNo" class="copy-number">
                            订单编号：{{ printItems.orderNo }}
                            <i
                                class="el-icon-document-copy numberCopy"
                                @click="numberCopy"
                            ></i>
                        </div>
                    </div>
                    <div class="itemBottom">
                        <div class="titleImg">
                            <div class="orderInfo">

                                <div v-if="printItems.orderType == 'PRINT'" class="imgThree demo-block-preview">
                                    <model-stl
                                        :backgroundAlpha="0"
                                        :rotation="rotation"
                                        :src="printItems.orderImg">
                                    </model-stl>
                                </div>
                                <img v-else :src="printItems.orderImg" alt="" />
                                <div class="infoContent">
                                    {{ printItems.orderName }}
                                </div>
                            </div>
                        </div>
                        <!-- <div  v-else style="width:413px" >
                            {{ printItems.orderName }}
                        </div> -->

                        <div class="invoiceTime">
                            <div>
                                {{ printItems.orderTypeCn }}
                            </div>

                        </div>

                        <div class="invoiceTime" >
                            {{ printItems.createDate }}
                        </div>

                        <!-- <div class="invoiceMes">
                            {{ printItems.invoiceName }}
                        </div> -->
                        <div class="invoiceClass" >
                            {{ printItems.invoiceType=='NORMAL'?'普通发票':'专用发票' }}
                        </div>

                        <div class="invoiceCon" >
                            {{ printItems.issueType=='ZZFP'?'纸质发票':'电子发票' }}
                        </div>

                        <div class="invoiceMoney" style="width:100px;text-align:center">
                            <span  v-if="printItems.invoiceMoney!='null'"> ￥{{ printItems.invoiceMoney }}</span>
                        </div>

                        <div class="status">
                            <div class="statusName">{{ printItems.invoiceStatus=='EXAMINE'?'开票中':printItems.invoiceStatus=='PASS'?'已开票':'已拒绝' }}</div>
                        </div>
                        <div class="operation" >
                            <div class="statusName" @click="toDetail(printItems)" >查看详情</div>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
            <div class="orderNomesaage" v-loading="loading" v-else >
                <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
            </div>
        </div>
    </div>
    <!-- 服务订单 -->
    <service-myInvoice v-if="nativeName == 'service'"></service-myInvoice>
    <!-- 设计订单 -->
    <design-myInvoice v-if="nativeName == 'design'"></design-myInvoice>
    <!-- 模型订单 -->
    <model-myInvoice v-if="nativeName == 'model'"></model-myInvoice>
    <!-- 商品订单 -->
    <shop-myInvoice v-if="nativeName == 'shop'"></shop-myInvoice>

    <el-pagination
      v-if="printMessage.length != 0"
      background
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
      layout="total,prev, pager, next,jumper"
      :current-page="current"
      :page-size="pageSize"
      :total="total"
      class="pagination"
    >
    </el-pagination>

      <el-dialog
          title="详情"
          :visible.sync="dialogVisible"
          :close-on-click-modal="false"
          width="800px">
          <div class="dialogBox">
              <div class="details">
                  <div class="invoiceInformation">
                      <h3 style="margin-top:0">发票信息</h3>
                      <div class="goodsItem">
                          <div class="label">发票要求：</div>
                          <div class="name">{{ activeName=='ZZFP'?'纸质发票':'电子发票' }}</div>
                      </div>
                      <div class="goodsItem">
                          <div class="label">发票类型：</div>
                          <div class="name">{{ invoiceInfo.invoiceType=='NORMAL'?'增值税普通发票':'增值税专用发票' }}</div>
                      </div>
                      <div class="goodsItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                          <div class="name">开票信息：</div>
                          <div class="content">{{ invoiceInfo.title }}
                              <el-popover
                                  placement="right"
                                  width="400"
                                  trigger="click">
                                  <div class="billingInformation ">
                                      <div class="title">开票信息</div>
                                      <div class="billingContent">
                                          <div class="billingItem">
                                              <div class="name">开票抬头：</div>
                                              <div class="content">{{ invoiceInfo.title }}</div>
                                          </div>
                                          <div class="billingItem">
                                              <div class="name">纳税人识别号：</div>
                                              <div class="content">{{ invoiceInfo.code }}</div>
                                          </div>
                                          <div class="billingItem">
                                              <div class="name">地址：</div>
                                              <div class="content">{{ invoiceInfo.code }}</div>
                                          </div>
                                          <div class="billingItem">
                                              <div class="name">电话：</div>
                                              <div class="content">{{ invoiceInfo.mobile }}</div>
                                          </div>
                                          <div class="billingItem">
                                              <div class="name">开户行：</div>
                                              <div class="content">{{ invoiceInfo.bank }}</div>
                                          </div>
                                          <div class="billingItem">
                                              <div class="name">账号：</div>
                                              <div class="content">{{ invoiceInfo.bankAccount }}</div>
                                          </div>
                                      </div>
                                  </div>
                                  <el-button type="text"  slot="reference" style="padding: 0 0 0 10px;"  v-if="invoiceInfo.invoiceType!=='NORMAL'">详细</el-button>
                              </el-popover>
                          </div>
                      </div>
                      <div class="goodsItem" v-if="activeName=='ZZFP'">
                          <div class="name">发票邮寄地址：</div>
                          <div class="content">{{ addressInfo.province }}{{ addressInfo.city }}{{ addressInfo.district }}{{ addressInfo.areaInfo }}</div>
                      </div>
                      <div class="goodsItem" v-else>
                          <div class="name">电子邮箱：</div>
                          <div class="content">{{ invoiceInfo.payeeEmail }}</div>
                      </div>
                  </div>
                  <div class="invoiceInformation">
                      <h3>开票结果</h3>
                      <div class="auditContent">
                          <el-tag type="warning" effect="dark" v-if="receiptStatus == 'EXAMINE'">开票中</el-tag>
                          <el-tag type="success" effect="dark" v-if="receiptStatus == 'PASS'">已开票</el-tag>
                          <el-tag type="danger" effect="dark"  v-if="receiptStatus == 'REFUSE'">已拒绝</el-tag>
                          <div class="cause" v-if="receiptStatus == 'PASS'">
                              <div class="causeTitle">开票凭证：</div>
                              <div class="causeContent">
                                  <img style="width: 100%;" :src="receiptUrl" alt="" v-if="receiptUrl">
                              </div>
                          </div>
                          <div class="cause" v-if="receiptStatus == 'REFUSE'">
                              <div class="causeTitle">驳回原因：</div>
                              <div class="causeContent">{{ remark }}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import { getAddressDetail,findInvoiceInfo } from '../../utils/interface';

import {getIssueInvoiceList} from '../../utils/issueInvoice'

import Clipboard from 'clipboard';
import serviceMyInvoice from './serviceMyInvoice'
import designMyInvoice from './designMyInvoice'
import modelMyInvoice from './modelMyInvoice'
import shopMyInvoice from './shopMyInvoice'
import ModelStl from 'vue-3d-model/src/model-stl'

export default {
  name: "myInvoice",
  components: {
    serviceMyInvoice,
    designMyInvoice,
    modelMyInvoice,
    shopMyInvoice,
    ModelStl
  },
  data() {
    return {
      nativeName: "",
      createDateValue: null,
      orderType:"",
      orderNo: "",
        orderStatusValue: "",
      //   分页
      current: 1,
      total: 0,
      pageSize: 10,
      loading: true,
      printMessage: [],
        //
        dialogVisible:false,
        addressInfo:"",
        invoiceInfo:"",
        activeName:"",
        receiptStatus:"",
        remark:"",
        receiptUrl:"",
        invoiceUuid:"",
        payeeUuid:"",
        invoiceStatus:"",
        rotation: {
            x: 200,
            y: 0,
            z: 100,
        },
    };
  },
    created(){
        this.searchOrderList();
    },
  methods: {
      searchInfo(){
        this.current = 1;
        this.searchOrderList();
      },
      searchOrderList(){
          this.loading = true
          this.printMessage = [];
          let params = {
              orderNo:this.orderNo,
              status:this.invoiceStatus,
              current:this.current,
              pageSize:this.pageSize,
              orderType:this.orderType,
              showType:'APPLY',
          };
          if(this.createDateValue != null){
              params.inputDate = this.createDateValue.join(" - ");
          }

          getIssueInvoiceList(params).then((res)=>{
              this.total = res.total;
              this.current = res.current;
              this.printMessage = res.data;
              console.log( this.printMessage)
              this.loading = false
          });
      },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      this.searchOrderList();
    },
    // 清除条件
    clearMessage() {
          this.invoiceStatus="";
      this.orderNo = "";
      this.orderType = "";
      this.createDateValue = "";
    },
    // 复制
    numberCopy() {
      // let _this = this;
      let clipboard = new Clipboard(".copy-number"); // 这里括号里填写上面点击事件绑定的class名
      clipboard.on("success", (e) => {
        // 复制成功，提示根据自己项目实际使用的UI来写
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制，提示根据自己项目实际使用的UI来写
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
      toDetail(item){
          // 查询按钮详情
          this.activeName = item.issueType;
          this.invoiceUuid = item.invoiceUuid;
          this.payeeUuid = item.payeeUuid;
          this.receiptStatus=item.invoiceStatus;
          this.receiptUrl=item.invoiceUrl;
          this.remark=item.remark;
          this.getInvoiceInfo();

          this.dialogVisible = true;
          this.title = "查看";
      },
      getInvoiceInfo(){
          if(this.invoiceUuid!=null){
              // 查询开票信息
              findInvoiceInfo({uuid:this.invoiceUuid}).then((res)=>{
                  this.invoiceInfo = res;
                //   console.log( this.invoiceInfo)
              });
          }
          if(this.payeeUuid!=null){
              // 查询地址详情
              getAddressDetail({uuid:this.payeeUuid}).then((res)=>{
                  this.addressInfo = res;
              });
          }
      },
  },
};
</script>

<style scoped lang="less">
    .myInvoiceBox {
        padding: 20px 20px 20px;
        .orderListTabs {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7;
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #e4e7ed;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }

        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }

        /deep/ .el-tabs__item.is-active {
            color: #3686d7;
        }

        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }
            /deep/.el-range-editor.el-input__inner {
                margin-right: 30px;
            }
            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
                margin-bottom: 22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom: 22px;
            }
        }

        .orderListTable {
            .orderNomesaage {
                color: #888;
                text-align: center;
                padding: 15px 0;
            }
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }

            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    margin-bottom: 16px;

                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;
                        .numberCopy {
                            cursor: pointer;
                        }

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 5px;
                                display: block;
                            }

                            img {
                                display: block;
                                padding-right: 5px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            display: flex;
                            align-items: center;
                            border-bottom: 1px solid #efefef;
                            justify-content: flex-start;
                            &:nth-last-child(1) {
                                border-bottom: none;
                            }

                            img {
                                display: block;
                                width: 100px;
                                height: 100px;
                                border-radius: 10px;
                                margin-right: 10px;
                            }
                            .imgThree {
                                width: 100px;
                                height: 100px;
                                border-radius: 10px;
                                margin-right: 30px;
                            }
                            .infoContent {
                                width: 140px;
                            }
                        }

                        .invoiceClass {
                            padding: 20px;
                        }

                        .argumentsName {
                            padding-bottom: 8px;
                        }
                        .invoiceCon {
                            h3 {
                                font-size: 14px;
                                font-weight: 700;
                                margin: 0;
                            }

                            .title {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                        .status {
                            font-size: 14px;
                        }
                        .operationBtn {
                            display: block;
                            color: #0c75d3;
                            text-align: center;
                            width: 100%;
                            margin: 0;
                        }
                        .operationBtnMoney {
                            color: #0c75d3;
                            padding: 6px 20px;
                            border: 1px solid #0c75d3;
                            border-radius: 6px;
                        }
                    }
                }
            }
            .titleImg {
                // flex: 1;
                width: 413px;

            }

            .invoiceTime {
                width: 160px;
                text-align: center;
                div {
                    border-bottom: 1px solid #efefef;
                    &:nth-last-child(1) {
                        border-bottom: none;
                    }
                }
            }
            .price2 {
                line-height: 140px;
            }

            .invoiceMes {
                width: 142px;
                text-align: center;
                div {
                    border-bottom: 1px solid #efefef;
                    &:nth-last-child(1) {
                        border-bottom: none;
                    }
                }
                .numborder {
                    border-right: 1px solid #efefef;
                }
            }
            .num2 {
                line-height: 140px;
            }

            .invoiceClass {
                text-align: center;
                width: 100px;
            }

            .invoiceCon {
                width: 162px;
                text-align: center;
            }

            .status {
                width: 124px;
                text-align: center;
            }

            .operation {
                width: 220px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                .statusName {
                    cursor: pointer;
                    color: #0c75d3;
                    padding: 6px 20px;
                    border: 1px solid #0c75d3;
                    border-radius: 6px;
                    margin-left: 10px;
                    margin-top: 12px;
                    &:nth-last-of-type(1) {
                        margin-bottom: 12px;
                    }
                }
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
        .invoiceInformation{
            width: 50%;
            padding-left:32px;
        }
        .goodsItem{
            display: flex;
            padding-bottom: 14px;
            font-size: 14px;
            .name{
                color: rgba(0, 0, 0, 0.85);
                min-width: 80px;
                flex-shrink: 0;
            }
            .content{
                color: rgba(0, 0, 0, 0.65);
                flex-shrink: 0;

            }
        }
        .billingInformation{
            .title{
                color: rgba(0, 0, 0, 0.85);
                padding: 5px 0 10px 15px;
                border-bottom: 1px solid #ddd;
                font-weight: 700;
            }
            .billingContent{
                padding: 10px 10px 0;
                color: rgba(0, 0, 0, 0.65);
                .billingItem{
                    display: flex;
                    padding-bottom: 10px;
                }
            }
        }
        .thumbnailClass{
            width: 100%;
            height: 130px;
            margin-right: 30px;
            .avatar{
                width: 130px;
                height: 130px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 130px;
                font-size: 24px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/service/myInvoice.vue